module.exports = __webpack_public_path__ + "img/41_42.6e80e1b8.png";